import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { formatDate } from 'src/utils/helperFunctions';
import moment from 'moment';

interface DateCellProps extends GridCellProps {
  dateOnly: boolean;
}

const DateCell: FC<React.PropsWithChildren<DateCellProps>> = ({ dataItem, field, dateOnly }) => {
  const hoursToAdd = dateOnly ? 8 : 0;
  const adjustedDate = dataItem[field] == null ? null : moment(dataItem[field]).add(hoursToAdd, 'hours').toDate();
  const fDate = formatDate(adjustedDate, 'MM/dd/yyyy');

  return (
    <td style={{ textAlign: 'right' }}>
      <span>
        {fDate}
      </span>
    </td>
  );
};

export default DateCell;
